var _style, _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewarkLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "203px",
    height: "64px",
    viewBox: "0 0 203 64",
    style: {
      enableBackground: "new 0 0 203 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4BB061;}\n\t.st1{fill:#FFFFFE;}\n\t.st2{fill:#0A0B09;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "86.1,51.2 86.1,64 193,64 197.2,51.2 86.1,51.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st1",
    d: "M95.6,58.4h1.5l-0.7-2.4L95.6,58.4z M97.5,59.6h-2.2l-0.5,1.6h-1.4l2.4-7H97l2.4,7H98L97.5,59.6z "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-4",
    className: "st1",
    points: "105.4,54.2 105.4,61.2 104.1,61.2 101.5,56.6 101.5,61.2 100.2,61.2 100.2,54.2  101.6,54.2 104.1,58.8 104.1,54.2 105.4,54.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    className: "st1",
    d: "M111.1,58.4h1.5l-0.7-2.4L111.1,58.4z M113,59.6h-2.2l-0.5,1.6h-1.4l2.4-7h1.3l2.4,7h-1.4 L113,59.6z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-6",
    className: "st1",
    points: "116.8,61.2 114.4,54.2 115.9,54.2 117.4,59.4 119,54.2 120.4,54.2 118.1,61.2  116.8,61.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-7",
    className: "st1",
    points: "126.4,54.2 126.4,61.2 125,61.2 122.5,56.6 122.5,61.2 121.2,61.2 121.2,54.2  122.5,54.2 125.1,58.8 125.1,54.2 126.4,54.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-8",
    className: "st1",
    points: "132.1,54.2 132.1,55.4 129.1,55.4 129.1,56.9 131.5,56.9 131.5,58.1 129.1,58.1  129.1,60 132.2,60 132.2,61.2 127.8,61.2 127.8,54.2 132.1,54.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-9",
    className: "st1",
    points: "133.2,54.2 138.3,54.2 138.3,55.4 136.4,55.4 136.4,61.2 135.1,61.2 135.1,55.4  133.2,55.4 133.2,54.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    className: "st1",
    d: "M146.4,56.6c-0.3-0.7-0.8-1.2-1.7-1.2c-1.1,0-2,0.8-2,2.4c0,1.6,0.9,2.4,2,2.4 c1,0,1.5-0.5,1.7-1.2l1.2,0.3c-0.3,1.3-1.4,2.1-2.9,2.1c-1.7,0-3.3-1.2-3.3-3.6c0-2.3,1.6-3.6,3.3-3.6c1.5,0,2.6,0.8,2.9,2.1 L146.4,56.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    className: "st1",
    d: "M149.8,57.7c0,1.7,0.9,2.4,2,2.4c1,0,2-0.7,2-2.4c0-1.7-0.9-2.4-2-2.4 C150.7,55.3,149.8,56.1,149.8,57.7z M155,57.7c0,2.4-1.5,3.6-3.3,3.6c-1.8,0-3.3-1.1-3.3-3.6c0-2.4,1.5-3.6,3.3-3.6 C153.5,54.2,155,55.3,155,57.7z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-12",
    className: "st1",
    points: "156.4,54.2 157.9,54.2 159.5,58.6 161.1,54.2 162.6,54.2 162.6,61.2 161.3,61.2  161.3,56.9 160,60.6 159,60.6 157.7,56.9 157.7,61.2 156.4,61.2 156.4,54.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    className: "st1",
    d: "M167.5,56.3c0-0.6-0.3-0.9-0.9-0.9h-1.3v1.8h1.3C167.2,57.3,167.5,57,167.5,56.3z M165.3,58.5 v2.7H164v-7h2.6c1.5,0,2.2,0.9,2.2,2.1c0,1.2-0.7,2.1-2.2,2.1H165.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    className: "st1",
    d: "M170.9,58.4h1.5l-0.7-2.4L170.9,58.4z M172.7,59.6h-2.2l-0.5,1.6h-1.4l2.4-7h1.3l2.4,7h-1.4 L172.7,59.6z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-15",
    className: "st1",
    points: "180.7,54.2 180.7,61.2 179.3,61.2 176.8,56.6 176.8,61.2 175.5,61.2 175.5,54.2  176.9,54.2 179.4,58.8 179.4,54.2 180.7,54.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-16",
    className: "st1",
    points: "182.7,54.2 183.9,56.9 185.2,54.2 186.6,54.2 184.6,58.2 184.6,61.2 183.3,61.2  183.3,58.2 181.3,54.2 182.7,54.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-18",
    className: "st2",
    d: "M30.7,50.3c-14.4-4.2-27.9-15.6-27.3-25c0.6-8.6,10.5-12.7,22.4-12C11,10.8,0.4,16.7,0.1,26.3 c-0.3,10.8,14.8,24.4,30.6,29.4L30.7,50.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    className: "st0",
    d: "M30.8,41.9c0,0-9.4-4.8-13-7.7c2.4,1.3,13,5.7,13,5.7v-1.8c0,0-8.7-4.3-13.5-7.9 c6.3,3.2,13.5,5.9,13.5,5.9l0-1.9c0,0-7.2-3-13.7-7.6c7.7,3.8,13.7,5.3,13.7,5.3V30C16.4,25.8,7.6,16.9,6.6,10.6 C5.4,2.2,14,0.5,25.9,1.2C11.1-1.3,0,0.8,0,13.6c0,10.9,15,24.6,30.8,29.6V41.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    className: "st2",
    d: "M30.9,8.5c14.4,4.2,27.9,15.6,27.3,25c-0.6,8.6-10.5,12.7-22.4,12c14.8,2.5,25.5-3.4,25.7-13 C61.7,21.7,46.7,8.1,30.9,3.1L30.9,8.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    className: "st0",
    d: "M30.7,16.9c0,0,9.4,4.8,13,7.7c-2.4-1.3-13-5.7-13-5.7v1.8c0,0,8.7,4.3,13.5,7.9 c-6.3-3.2-13.5-5.9-13.5-5.9v1.9c0,0,7.2,3,13.7,7.6C36.7,28.5,30.7,27,30.7,27v1.8C45.2,33,54,41.9,54.9,48.2 c1.3,8.4-7.4,10.1-19.3,9.4c14.8,2.5,25.9,0.4,25.9-12.4c0-10.8-15-24.6-30.8-29.6V16.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-23",
    className: "st2",
    points: "79.3,15.4 91.7,34.5 91.7,15.4 95.6,15.4 95.6,41.4 92,41.4 79.3,22.4 79.3,41.4  75.5,41.4 75.5,15.4 79.3,15.4  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-24",
    className: "st2",
    d: "M108,24.2c-1.4,0-2.5,0.5-3.4,1.5s-1.5,2.4-1.7,4.3h10.1c-0.2-1.9-0.8-3.3-1.7-4.3 C110.5,24.7,109.4,24.2,108,24.2z M103,32.6c0.1,1,0.3,1.9,0.6,2.7c0.3,0.8,0.7,1.4,1.2,1.9c0.5,0.5,1,0.9,1.7,1.1 c0.6,0.2,1.2,0.4,1.9,0.4c1,0,1.8-0.2,2.6-0.7c0.7-0.5,1.3-1,1.8-1.7l2.4,2.1c-0.3,0.4-0.6,0.8-1,1.2c-0.4,0.4-0.9,0.8-1.5,1.1 c-0.6,0.3-1.2,0.6-1.9,0.8c-0.7,0.2-1.5,0.3-2.4,0.3c-1.2,0-2.3-0.2-3.3-0.7c-1.1-0.4-2-1.1-2.7-2c-0.8-0.9-1.4-2-1.8-3.3 c-0.5-1.3-0.7-2.9-0.7-4.6c0-1.7,0.2-3.1,0.6-4.4c0.4-1.3,1-2.4,1.7-3.3c0.7-0.9,1.6-1.5,2.7-2c1-0.5,2.2-0.7,3.4-0.7 c1.2,0,2.4,0.2,3.4,0.7c1,0.5,1.9,1.1,2.7,2c0.8,0.9,1.3,2,1.7,3.3c0.4,1.3,0.6,2.8,0.6,4.4c0,0.3,0,0.5,0,0.7 c0,0.2,0,0.4-0.1,0.6H103z"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-25",
    className: "st2",
    points: "120.7,21.5 124.1,35.5 128.4,21.5 131.3,21.5 135.4,35.5 138.9,21.5 142.3,21.5  137.3,41.4 134.1,41.4 129.8,27 125.3,41.4 122.2,41.4 117.3,21.5 120.7,21.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-26",
    className: "st2",
    d: "M151.8,38.7c0.8,0,1.6-0.1,2.5-0.3c0.9-0.2,1.7-0.5,2.4-0.9V32c-0.7-0.3-1.4-0.4-2.2-0.6 c-0.8-0.1-1.5-0.2-2.2-0.2c-1.4,0-2.6,0.3-3.6,0.9c-1,0.6-1.5,1.6-1.5,2.9c0,0.7,0.1,1.2,0.4,1.7c0.2,0.5,0.6,0.8,1,1.1 c0.4,0.3,0.9,0.5,1.4,0.6C150.6,38.6,151.2,38.7,151.8,38.7z M145.4,23.1c0.7-0.6,1.7-1,2.9-1.5c1.2-0.4,2.6-0.6,4.2-0.6 c1.1,0,2.2,0.1,3.1,0.4c0.9,0.3,1.8,0.7,2.4,1.3c0.7,0.6,1.2,1.4,1.6,2.4c0.4,1,0.6,2.2,0.6,3.7v12.6h-3.3v-1.4 c-1.7,1.1-3.7,1.7-5.9,1.7c-1,0-1.9-0.1-2.8-0.4c-0.9-0.3-1.6-0.6-2.3-1.2c-0.6-0.5-1.1-1.2-1.5-2c-0.4-0.8-0.6-1.8-0.6-2.9 c0-1.1,0.2-2,0.6-2.9c0.4-0.8,0.9-1.5,1.6-2.1c0.7-0.6,1.5-1,2.4-1.3c0.9-0.3,1.9-0.4,3-0.4c0.9,0,1.8,0.1,2.7,0.3 c0.9,0.2,1.8,0.4,2.6,0.8V29c0-0.9-0.1-1.6-0.3-2.2c-0.2-0.6-0.5-1.1-0.9-1.4c-0.4-0.4-0.9-0.6-1.5-0.8c-0.6-0.1-1.2-0.2-1.9-0.2 c-1.1,0-2,0.1-2.9,0.4c-0.9,0.3-1.7,0.7-2.4,1.2L145.4,23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-27",
    className: "st2",
    d: "M176.3,25.4c-0.4-0.4-0.8-0.6-1.2-0.8c-0.5-0.1-1-0.2-1.6-0.2c-1,0-1.9,0.2-2.8,0.7 c-0.8,0.5-1.5,1.4-2.1,2.8v13.4H165V21.5h3.4v2.4c1.4-1.9,3.3-2.9,5.7-2.9c0.9,0,1.6,0.1,2.1,0.4c0.6,0.2,1,0.5,1.4,0.8 L176.3,25.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-28",
    className: "st2",
    points: "196.4,21.5 189.5,29.3 197.5,41.4 193.6,41.4 187.3,31.9 183.9,35.7 183.9,41.4  180.4,41.4 180.4,14.8 183.9,13.6 183.9,31.3 192.5,21.5 196.4,21.5  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewarkLogo);
export default __webpack_public_path__ + "static/media/newark-logo.b0cbb2b561441242d0a6abf524ac69d9.svg";
export { ForwardRef as ReactComponent };